export default "__VITE_ASSET__BfGUjJqq__"